import { css } from "styled-components";
export const riotProductSkin = (chroma, paletteTokens) => css `
  ${chroma.typography.body4};
  display: flex;
  flex-direction: column;
  width: 100%;

  input {
    ::placeholder {
      color: ${paletteTokens.bladetext1_light};
      opacity: 1; /* Firefox */
    }

    all: unset;
    display: block;
    border-radius: 2px;
    cursor: text;
    color: ${paletteTokens.bladetext1};
    background-color: ${chroma.input.background};
    border: none;
    border-bottom: 1px solid ${paletteTokens.bladetext1_light};
    width: 100%;
    padding: 8px 0;
    ${chroma.typography.display7}

    &:invalid,
    &[data-valid="false"] {
      border-bottom: 1px solid ${chroma.input.borderInvalid};
    }

    &:disabled {
      background-color: ${chroma.input.backgroundDisabled};
    }
  }
`;
//# sourceMappingURL=index.js.map